import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";


interface StatusNotificationCollectionOptions {
    userGroupId: number
}

export class StatusNotificationCollection extends CachingCollection<Backbone.Model> {

    userGroupId: number;

    constructor(initialModels: Object[] | any[], options: StatusNotificationCollectionOptions) {
        super(initialModels, options);
        this.userGroupId = options ? options.userGroupId : null;
    }

    url = () => {
        return '/api/v1/notifications/status/' + this.userGroupId
    };

    comparator = (model) => {
        return model.get('order');
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/StatusNotifications.ts